import { EditorSection } from '../EditorSection';
import { usePlotEditorContext } from '../PlotEditorContext';
import { TitleControls } from '../title-controls';
import { AnnotationControls } from '../annotation-controls';

/**
 * Labels & Annotations Tab
 * Primary: Titles, data labels
 * Advanced: Full annotation editor
 */
export function LabelsAnnotationsTab() {
  const { plotlyJson, onUpdate } = usePlotEditorContext();

  return (
    <div className="space-y-4">
      {/* Section heading */}
      <div className="space-y-1">
        <h3 className="text-xs font-semibold text-foreground">Labels & Annotations</h3>
        <p className="text-[11px] text-muted-foreground">
          Add titles, subtitles, and annotations to your plot.
        </p>
      </div>

      {/* Titles */}
      <div className="space-y-2">
        <p className="text-[10px] font-semibold uppercase tracking-[0.08em] text-muted-foreground">
          Titles
        </p>
        <TitleControls plotlyJson={plotlyJson} onUpdate={onUpdate} />
      </div>

      {/* Annotations */}
      <div className="space-y-2">
        <p className="text-[10px] font-semibold uppercase tracking-[0.08em] text-muted-foreground">
          Annotations & Shapes
        </p>
        <AnnotationControls plotlyJson={plotlyJson} onUpdate={onUpdate} />
      </div>
    </div>
  );
}

